import ControlledInput from './ControlledInput.jsx';
import {
  formatInternationalZipCode,
  formatZipCode,
  internationalZipCodeRules,
  zipCodeRules
} from '@@viewHelpers/validations';

export const POSTAL_CODE_FIELD = 'customer.addresses.0.zipCode';

const ControlledPostalCode = ({
  form,
  getMiddleText,
  isDisplayed = true,
  isRequired = false,
  disabled = false,
  displayFrenchFields = true,
  displayForeignFields = false,
  postalCodeFranceMetro,
  postalCodeDROM,
  displayErrorMessage = false,
  name,
  postalCodeLabel,
  internationalZipCodeLabel,
  postalCodeTestId,
  internationalZipCodeTestId
}) => {
  if (!isDisplayed) {
    return null;
  }

  return (
    <>
      <ControlledInput
        name={name}
        label={postalCodeLabel}
        form={form}
        rules={zipCodeRules(isRequired, postalCodeFranceMetro, postalCodeDROM)}
        formatValue={formatZipCode}
        disabled={disabled}
        displayErrorMessage={displayErrorMessage}
        data-testid={postalCodeTestId}
        isDisplayed={displayFrenchFields}
      />
      <ControlledInput
        name={name}
        label={internationalZipCodeLabel }
        form={form}
        rules={internationalZipCodeRules(isRequired)}
        formatValue={formatInternationalZipCode}
        // Jamais verrouillé : hors France l'étape contrat ne collecte pas le code postal,
        // le figer laisserait un champ vide et non saisissable.
        displayErrorMessage={displayErrorMessage}
        data-testid={internationalZipCodeTestId}
        isDisplayed={displayForeignFields}
      />
    </>
  );
};

export default ControlledPostalCode;
